import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'div.page',
    template: '<router-outlet></router-outlet>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {

}
